import React, { useEffect } from 'react';
import { trackPageVisit, PAGE_NAME } from '../../utils/tracking';
import Container from '../../components/Container';
import ExternalLink from '../../components/ExternalLink';
import Button from '../../components/Button';
import Footer from '../../components/Footer';

import { srOnly, unstyledList } from '../../base-styles/mixins.module.css';
import styles from './styles.module.css';

interface Props {
  routeParams: {
    inviteCode: string;
  };
}

const SquadsAcceptInvitePage = (props: Props) => {
  const {
    routeParams: { inviteCode },
  } = props;

  useEffect(() => {
    trackPageVisit(PAGE_NAME.SQUADS_ACCEPT_INVITE_PAGE, inviteCode);
  }, []);
  return (
    <>
      <section className={styles.section}>
        <Container className={styles.container} hideMargins={false}>
          <header>
            <h1 className={styles.heading}>Welcome to Squads</h1>
            <p>
              Squads is the app to get you doing challenges with your friends.
              Let&apos;s get you involved!
            </p>
          </header>
        </Container>
      </section>

      <div className={styles.links}>
        <Container className={styles.container} hideMargins={false}>
          <section className={styles.section}>
            <h2 className={styles.subheading}>
              Haven&apos;t got the app yet? Find us on the Apple App Store and Google Play
            </h2>
            <ul className={unstyledList}>
              <li key="https://apps.apple.com/us/app/id1512743210">
                <ExternalLink
                  href="https://apps.apple.com/us/app/id1512743210"
                  follow
                >
                  <img
                    src="https://res.cloudinary.com/letsdothiscom/image/upload/v1591966882/group-challenges/static-assets/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
                    alt="Apple App Store Download Link"
                  />
                </ExternalLink>
              </li>
              <li key="https://play.google.com/store/apps/details?id=com.letsdothis.app">
                <ExternalLink
                  href="https://play.google.com/store/apps/details?id=com.letsdothis.app"
                  follow
                >
                  <img
                    src="https://res.cloudinary.com/letsdothiscom/image/upload/v1591966869/group-challenges/static-assets/google-play-badge.png"
                    alt="Google Play Store Download link"
                  />
                </ExternalLink>
              </li>
            </ul>
          </section>
        </Container>
      </div>

      <section className={styles.section}>
        <Container className={styles.container} hideMargins={false}>
          <header>
            <h2 className={styles.subheading}>
              Got your squad invite? Join up!
            </h2>
            <ExternalLink
              href={`letsdothis://acceptinvite/${inviteCode}`}
              follow
            >
              <Button primary>Accept Invite</Button>
            </ExternalLink>
          </header>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default SquadsAcceptInvitePage;
